import { useEffect, useState } from "react";

export const useIsMobile = () => {
  const [width, setWidth] = useState<number | null>(null);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }


  useEffect(() => {
    if(typeof window !== "undefined") setWidth(window.innerWidth)
    window.addEventListener("resize", handleWindowSizeChange);
    return () => window.removeEventListener("resize", handleWindowSizeChange);
  }, []);
  return width ? width <= 768 : 0;
};
